import './index.scss';
import 'components/lesson_player/notes/index.scss';

import 'components/modals/basic_modal';
import ModalManager from 'utils/modal_manager';
import {handleApiError} from 'utils/api_error_handler';

export default class LessonNotesTab {
  constructor($context) {
    vendorManager.ensure('quill', () => {
      this.$context = $context;
      this.$lessonAnnotationArea = false;
      this.$noteForm = $('.js-create-note-form', this.$context);
      this.$annotationBtn = $('.q-annotation-action-btn', this.$context);
      this.instantiateQuill();
      this.bind();
    });
  }

  instantiateQuill() {
    const $editor = $('#annotation-target', this.$context);

    if (!$editor.length || $editor.hasClass('ql-container')) return;

    this.editor = new Quill($editor.get(0), {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{color: [false, 'red', 'green', 'blue']}]
        ]
      },
      placeholder: 'Descreva a sua anotação...',
      theme: 'snow'
    });

    this.$lessonAnnotationArea = $('.ql-editor', this.$context);

    this.fillQuillContent();
    this.collapseQuill();
  }

  fillQuillContent() {
    const $annotationValueElement = $(
      '.js-annotation-value',
      this.$context
    ).val();

    if (
      $annotationValueElement !== '' &&
      $annotationValueElement !== '<p> </p>'
    ) {
      this.$noteForm.addClass('q-lesson-player-annotation-edit');
    }

    this.$quillContent = $('.ql-editor', this.$context);
    this.$quillContent.html($annotationValueElement);
  }

  bind() {
    const $createForm = $('.js-create-note-form', this.$context);

    $createForm
      .ajaxForm(false)
      .lazyReady()
      .on('submit', e => {
        e.preventDefault();
        if (this._validateAnnotationArea()) this.saveNote(e);
        return false;
      });

    $('.js-edit-note-btn', this.$context).on('click', () => this.editNote());
    $('.js-cancel-note-btn', this.$context).on('click', () => this.cancelNote());
    $('.js-delete-note-btn', this.$context).on('click', e => this.deleteNote(e));
    $('.js-save-note-btn', this.$context).on('click', e => this.newSaveNote(e));
  }

  saveNote(e) {
    this.$lessonAnnotationArea = $('.ql-editor', this.$context).html();

    $('.js-annotation-value').val(this.$lessonAnnotationArea);
    const $createForm = $('.js-create-note-form', this.$context);
    const data = $createForm.serializeObject();
    const annotation_id = $(e.currentTarget).data('annotation-id');
    const method = typeof annotation_id === 'undefined' ? 'create' : 'update';
    this.editor.enable(false);

    Thor.LessonAnnotation[method](
      annotation_id
        ? {
          id: annotation_id
        }
        : {},
      {
        data: data
      }
    )
      .then(annotation => {
        $createForm.trigger('ajax:success');
        if (method === 'create') this.bindNewId(annotation.id);
      })
      .catch(({response}) => $createForm.trigger('ajax:error', response));
  }

  newSaveNote(e) {
    this.saveNote(e);
    this.$noteForm.removeClass('q-lesson-player-annotation-save');
    this.$noteForm.addClass('q-lesson-player-annotation-edit');
    this.$annotationBtn.removeClass('q-lesson-player-annotation-btn-save');
    this.editor.enable(false);
  }

  editNote() {
    this.$noteForm.removeClass('q-lesson-player-annotation-edit');
    this.$noteForm.addClass('q-lesson-player-annotation-save');
    this.$annotationBtn.addClass('q-lesson-player-annotation-btn-save');
    this.editor.enable(true);
  }

  cancelNote() {
    const $annotationValueElement = $(
      '.js-annotation-value',
      this.$context
    ).val();

    this.$noteForm.addClass('q-lesson-player-annotation-edit');
    this.$noteForm.removeClass('q-lesson-player-annotation-save');
    this.$annotationBtn.removeClass('q-lesson-player-annotation-btn-save');
    this.$quillContent.html($annotationValueElement);
    this.editor.enable(false);
  }

  deleteNote(e) {
    ModalManager.open('#js-confirm-delete-note-modal', res => {
      if (!res) return;

      const annotationId = $(e.currentTarget).data('annotation-id');
      Thor.LessonAnnotation.delete({
        id: annotationId
      }, {}).then(() => {
        toastr.success('Anotação excluída com sucesso!');
        this.$noteForm.removeClass('q-lesson-player-annotation-edit');
        this.editor.setText('');
        this.editor.enable(true);
      }).catch(({response}) => {
        handleApiError('Ops! Não foi possível excluir sua anotação nesse momento!', response);
      });
    });
  }

  _validateAnnotationArea() {
    const hasBlankClass = $('.ql-editor', this.$context).hasClass('ql-blank');
    const isWhiteSpace = this.$quillContent.html() === '';

    if (!hasBlankClass && !isWhiteSpace) {
      this.$noteForm.addClass('q-lesson-player-annotation-edit');
      return true;
    } else {
      toastr.warning('Seu comentário não pode ser vazio.');
      return false;
    }
  }

  collapseQuill() {
    const $quillContext = $('.q-lesson-player-notes-quill', this.$context);
    const $icon = $('.q-icon', $quillContext);
    const $collapseButton = $('.collapse', $quillContext);

    $collapseButton.on('show.bs.collapse', () => {
      $icon.removeClass('q-icon-angle-down');
      $icon.addClass('q-icon-angle-up');
    });

    $collapseButton.on('hidden.bs.collapse', () => {
      $icon.removeClass('q-icon-angle-up');
      $icon.addClass('q-icon-angle-down');
    });
  }

  bindNewId(id) {
    $('.js-delete-note-btn', this.$context).data('annotation-id', id);
    $('.js-save-note-btn', this.$context).data('annotation-id', id);
  }
}
